/* Berkeley Life · midlife women LP
   Progressive enhancement only. Every interactive thing on this page
   works with this file deleted: the plan picker is real radios driven
   by :checked, Supplement Facts is a checkbox modal, the FAQ is native
   <details>, and the chart renders at full length with no JS. This
   file adds live review counts, the sheet's copy of the proof
   sections and its background warm-up, the draw-once chart, the
   clinician quotes' rise-in, the reveal for the reviews block, the
   strip gate's drag, the offer sheet's scroll lock, and the
   subscription cart call. */

(function () {
  'use strict';

  var root = document.getElementById('bl-lp');
  if (!root) return;

  /* ---------- 1 · live Okendo numbers ----------
     Reads the hidden star-rating widget's payload so the rating bar,
     the offer stars and the reviews block can never contradict each
     other. Printed values in the HTML are the no-JS fallback. */

  function readOkendo() {
    var src = root.querySelector('.ratingbar__source');
    if (!src) return false;
    var avg = src.querySelector('[data-oke-star-rating-value]');
    var cnt = src.querySelector('[data-oke-star-rating-count]');
    if (!avg || !cnt) return false;
    var a = parseFloat(avg.textContent);
    var c = parseInt((cnt.textContent || '').replace(/[^\d]/g, ''), 10);
    if (!a || !c) return false;
    /* By class, not by id: the count now prints in the rating bar AND
       in the written-reviews intro, and those two saying different
       numbers on one page is the exact failure this function exists to
       prevent. Add .js-rating-count anywhere else it needs to appear. */
    fill('.js-rating-avg', a.toFixed(1));
    fill('.js-rating-count', String(c));
    return true;
  }

  function fill(sel, text) {
    var nodes = root.querySelectorAll(sel);
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = text;
  }

  var okendoTries = 0;
  var okendoTimer = setInterval(function () {
    if (readOkendo() || ++okendoTries > 20) clearInterval(okendoTimer);
  }, 500);

  /* ---------- 1a · the sheet's copy of the proof ----------
     Per Ewan 6 Aug: the UGC reels and the written reviews appear in
     the offer sheet as well as on the page. The sheet copy is CLONED
     from the page copy rather than authored twice, so the two
     surfaces cannot drift — the same rule .js-rating-count already
     enforces for the numbers. Landed between the offer and the FAQ:
     offer, proof, objections.

     ORDER MATTERS IN THIS FILE. This runs before 1b so the clone is
     taken while the markup is still pristine (every review visible,
     the Read More button still hidden), and before 5 so the reels
     wiring picks up both copies — which also puts the sheet videos in
     the same mute group, so a testimonial in the sheet and one on the
     page can never talk over each other.

     Ids inside the copy are prefixed "sheet-" so nothing on the page
     is duplicated; 1b finds the copy's Read More parts under those
     names. With this file deleted the sheet simply has no proof
     sections, which is the correct failure direction: in that state
     the page copy ships visible, one Back away. */

  (function () {
    var sheetCol = root.querySelector('#offer-sheet .sheet__col');
    if (!sheetCol) return;
    var faq = sheetCol.querySelector('.faq');
    if (!faq) return;

    ['ugc', 'reviews'].forEach(function (id) {
      var sec = document.getElementById(id);
      if (!sec) return;
      var copy = sec.cloneNode(true);
      copy.id = 'sheet-' + id;
      copy.querySelectorAll('[id]').forEach(function (el) {
        el.id = 'sheet-' + el.id;
      });
      copy.querySelectorAll('[aria-controls]').forEach(function (el) {
        el.setAttribute('aria-controls', 'sheet-' + el.getAttribute('aria-controls'));
      });
      /* Not metadata at load — the page copy is already fetching the
         same bytes. 1c raises this once the page has gone idle, so
         the first frame is cached before she ever opens the sheet. */
      copy.querySelectorAll('video').forEach(function (v) {
        v.preload = 'none';
      });
      sheetCol.insertBefore(copy, faq);
    });

    /* The plan ratings jump to #reviews, which is the PAGE copy —
       hidden behind the open sheet. Point them at the copy that is
       actually in front of her. Without JS there is no sheet copy and
       the page copy is visible, so the authored href stays right. */
    if (document.getElementById('sheet-reviews')) {
      sheetCol.querySelectorAll('.convert__rating').forEach(function (a) {
        a.setAttribute('href', '#sheet-reviews');
      });
    }
  })();

  /* ---------- 1b · reviews, five at a time ----------
     Progressive enhancement, same contract as everything else on this
     page: the markup ships every review visible and the button hidden,
     so with this file deleted the reader gets all of them and no
     control. This only ever REMOVES content and then hands back a way
     to get it again.

     Five per tap. The button lives after the list, so revealing a batch
     pushes it down under the newest review rather than collapsing the
     stack — she never loses her place, and the reviews she has already
     read stay where they were. It removes itself when the list runs
     out; a dead control that still looks live is worse than none.

     Runs once per surface: the page copy and the sheet copy 1a built
     each get their own button and their own counter, so how far she
     has read on one has no bearing on the other. */

  function initReadMore(list, btn, note) {
    if (!list || !btn) return;

    var STEP = 5;
    var items = [];
    for (var n = 0; n < list.children.length; n++) items.push(list.children[n]);

    var shown = 0;
    for (var h = 0; h < items.length; h++) items[h].hidden = true;
    btn.hidden = false;
    /* The FTC note waits with them. It reappears with the last batch,
       so the button is the only thing under the reviews until there is
       nothing left to reveal. */
    if (note) note.hidden = true;

    btn.addEventListener('click', function () {
      var firstNew = items[shown];
      shown = Math.min(shown + STEP, items.length);
      for (var i = 0; i < items.length; i++) items[i].hidden = i >= shown;

      /* Focus the first review of the new batch rather than letting it
         sit on a button that just moved down the page. -1 keeps it out
         of the tab order; screen readers still land on the new content
         instead of announcing nothing. */
      if (firstNew) {
        firstNew.setAttribute('tabindex', '-1');
        firstNew.focus({ preventScroll: true });
      }

      if (shown >= items.length) {
        btn.hidden = true;
        if (note) note.hidden = false;
      }
    });
  }

  initReadMore(document.getElementById('bl-more-reviews'),
               document.getElementById('bl-more-btn'),
               document.getElementById('bl-reviews-note'));
  initReadMore(document.getElementById('sheet-bl-more-reviews'),
               document.getElementById('sheet-bl-more-btn'),
               document.getElementById('sheet-bl-reviews-note'));

  /* ---------- 1c · warm the sheet while she reads ----------
     Per Ewan 6 Aug: everything the sheet needs should already be in
     the cache by the time she opens it, not fetched in a burst the
     moment she taps a door. The kit shots, the Supplement Facts panel
     and the review photos are all authored lazy, and lazy inside a
     closed popover means NEVER — so the whole bill used to come due
     on first open.

     Trigger is the load event or her first scroll, whichever comes
     first, and the work itself waits for an idle slot — a warm-up
     that competes with the article it is warming up for has its
     priorities backwards. It then flips the sheet's lazy images to
     eager at low fetch priority and lets the cloned videos fetch
     their metadata, which is the frame the box paints before play
     starts. The full streams are NOT prefetched: six HD streams is
     not a warm-up, it is a download. And because the sheet copy
     shares every URL with the page copy, this warms the hidden
     social-proof block on the page for free.

     SKIPPED on Save-Data and 2G, where the open pays its own way
     rather than this file spending her allowance on a sheet she may
     never open. In every case the failure direction is today's
     behavior: this only moves fetches earlier, it never adds one
     that would not have happened. */

  (function () {
    var warmSheet = document.getElementById('offer-sheet');
    if (!warmSheet) return;

    var conn = navigator.connection;
    if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;

    var warmed = false;
    function warm() {
      if (warmed) return;
      warmed = true;
      window.removeEventListener('scroll', hurry);

      warmSheet.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
        /* Low priority: she is mid-article, and nothing in a closed
           sheet should compete with what she is actually reading. */
        img.setAttribute('fetchpriority', 'low');
        img.loading = 'eager';
      });
      warmSheet.querySelectorAll('video').forEach(function (v) {
        if (v.preload === 'none') v.preload = 'metadata';
      });
    }

    function idleWarm() {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(warm, { timeout: 6000 });
      } else {
        setTimeout(warm, 2500);
      }
    }

    function hurry() { idleWarm(); }

    if (document.readyState === 'complete') {
      idleWarm();
    } else {
      window.addEventListener('load', idleWarm, { once: true });
    }
    window.addEventListener('scroll', hurry, { once: true, passive: true });
  })();

  /* ---------- 2 · the two SVG charts draw once ----------
     Plays on first entry and never again. Text is never gated behind
     it: if this never fires, CSS leaves the chart at full length.
     Skipped entirely under prefers-reduced-motion, where the CSS
     already renders the finished state.

     The FMD chart, the lifespan schematic and the strip diagram all
     use this, on the same contract — the only difference between them
     lives in CSS. */

  var motionOK = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canObserve = 'IntersectionObserver' in window;

  function drawOnce(el) {
    if (!el) return;

    /* No observer, or motion is unwanted: land on the finished state
       immediately. Never leave a chart parked at zero length. */
    if (!canObserve || !motionOK) {
      el.classList.add('is-drawn');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-drawn');
          io.unobserve(e.target);
          unpark(rec);
        }
      });
    }, { threshold: 0.35 });
    var rec = { el: el, io: io };
    io.observe(el);

    drawParked.push(rec);
    /* onScroll is a function declaration further down this same scope,
       so it is hoisted and safe to bind here. Nothing can fire before
       this IIFE finishes. */
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* THE CHARTS HAD NO FAIL-OPEN, AND THE SWEEP BELOW WAS WRITTEN FOR
     EXACTLY THIS FAILURE. Found 12 Aug.

     The long note on the sweep describes it precisely — "a fast flick,
     an anchor jump or a restored scroll position can move a figure from
     below the fold to above it between two observations — ratio 0
     before, ratio 0 after, no threshold crossed, no callback ever" —
     and then guards riseOnce with it and leaves drawOnce bare. The
     reasoning was written once and wired to one of the two functions it
     applies to.

     drawOnce is the worse one to leave open. riseOnce parks with
     opacity, so a missed callback costs an entrance. These charts park
     in the STYLESHEET at zero: .fmd__line at stroke-dashoffset 192,
     .strip's contents at opacity 0. A missed callback there does not
     lose an animation, it loses the data. Frame, title, subtitle, axis
     ticks, caption and the full citation all render with nothing
     plotted inside them, under a source line naming a real study. It
     reads as broken rather than absent, which is the worse failure.

     MEASURED, after twelve fast scroll ticks down the article:
       .fmd    drawn, bottom -6496
       .arc    drawn, bottom -5640
       .strip  NOT drawn, bottom -809, still parked
     Twelve sweeps had run by then, so the scroll plumbing was healthy
     and the observer simply never got a threshold crossing. Scrolling
     back up does not recover it. Blank for the rest of the session.

     WHICH FIGURE IT HITS IS LUCK. It is whichever chart the reader's
     scroll rhythm happens to step over. Figure 3 was the first sighting
     and Figure 8 was the reproduction. Under ordinary reading pace all
     three draw correctly, which is why this survived this long.

     THE BACKSTOP ONLY FIRES WHERE THE OBSERVER CANNOT, and that is the
     entire design. Drawing on the same 0.88 RISE_LINE the other sweep
     uses would preempt the 0.35 threshold on every ordinary scroll and
     quietly retime all three charts for everyone, which is a worse bug
     than the one being fixed. So it draws in only the two states from
     which no threshold crossing is still coming:

       bottom <= 0                  scrolled past, above the viewport
       top <= 0 && bottom >= vh     taller than the screen and filling
                                    it, so the ratio cannot reach 0.35
                                    at any scroll position

     Anything else self-heals: a figure sitting at ratio < 0.35 gets its
     callback as soon as she keeps scrolling. */
  var drawParked = [];   // {el, io} awaiting a threshold that may not come

  function unpark(rec) {
    var i = drawParked.indexOf(rec);
    if (i !== -1) drawParked.splice(i, 1);
    unbindSweepIfIdle();
  }

  function drawNow(rec) {
    if (drawParked.indexOf(rec) === -1) return;
    rec.io.unobserve(rec.el);
    rec.el.classList.add('is-drawn');
    unpark(rec);
  }

  drawOnce(root.querySelector('.fmd'));
  drawOnce(root.querySelector('.arc'));
  drawOnce(root.querySelector('.strip'));

  /* The other half of the entrance vocabulary, used by every exhibit
     whose hidden state must NOT be parked in the stylesheet: the
     quotes (§2d) and the five text-and-photograph figures (§2e).

     Same contract as drawOnce — first entry only, never replays — but
     the parked state is applied from here rather than from CSS, because
     these exhibits are readable content and the header rule stands:
     text and photographs are never gated on this file firing. A dead
     observer (no IntersectionObserver, reduced motion, a script error
     above) leaves every figure untouched and visible.

     WHERE .is-parked GOES, AND WHY IT MOVED. It used to be applied
     inside the observer callback, a forced reflow before .is-in. That
     is wrong for anything the reader can already see: the callback
     fires when the figure is a third of the way up the viewport, so
     she watched a photograph she was already looking at blank itself
     and fade back. Five figures doing that is the "stuttery, weird"
     read the charts never had — .fmd and .arc park in the stylesheet
     at load, long before they are on screen, which is exactly the
     property that makes their entrances feel clean.

     So parking now happens at observe() time, while the figure is
     still below the fold and unseen, and the callback only adds
     .is-in. Fail-open survives intact: parking is still done from JS,
     so with this file deleted no class ever lands. And riseOnce still
     declines anything already on screen at load, which is now the only
     case that could park something in view.

     Threshold is 0 with a bottom rootMargin instead of 0.35: a figure
     taller than the viewport can never reach 35% intersection, so tall
     exhibits on a phone were parking and then never being told to
     reveal. Firing on the first sliver, held back by the margin so it
     still starts as she arrives at it, has no such dead zone. */

  /* The load-time skip rule. Deliberately ANY visible pixel, not the
     old 35%: parking is now permanent until the observer answers, so
     the cost of parking something the reader can see is no longer a
     flicker, it is a figure she watched vanish. A figure already in
     view has nothing to reveal — leave it exactly as the markup shipped
     it and never observe it at all. */
  function anyOfItVisible(box) {
    return box.bottom > 0 && box.top < window.innerHeight;
  }

  /* The reveal line: a figure starts its entrance once its top edge is
     12% of the viewport up from the bottom. Shared by the observer (as
     a rootMargin) and by the sweep below (as arithmetic), so the two
     can never disagree about when a figure is due. */
  var RISE_LINE = 0.88;

  var parked = [];   // observed, parked, not yet revealed

  /* Both lists share one scroll listener, so it only comes off when
     both are empty. Called from reveal() and from unpark(). */
  function unbindSweepIfIdle() {
    if (!parked.length && !drawParked.length) {
      window.removeEventListener('scroll', onScroll);
    }
  }

  function reveal(el) {
    var i = parked.indexOf(el);
    if (i === -1) return;
    parked.splice(i, 1);
    riseIO.unobserve(el);
    el.classList.add('is-in');
    unbindSweepIfIdle();
  }

  /* THE SWEEP IS NOT BELT AND BRACES, IT IS THE FAIL-OPEN GUARANTEE.
     IntersectionObserver only queues an entry when a threshold is
     CROSSED. A fast flick, an anchor jump or a restored scroll position
     can move a figure from below the fold to above it between two
     observations — ratio 0 before, ratio 0 after, no threshold crossed,
     no callback ever. That was harmless while parking happened inside
     the callback (no callback meant no parking, so the figure stayed
     visible). Now that parking happens up front, a missed callback
     would leave an exhibit invisible for the rest of the session.

     So the observer decides WHEN a figure rises, and this decides THAT
     it rises. Anything already past the reveal line is revealed here
     regardless of what the observer did or did not deliver. It
     unbinds itself once the last figure is up.

     IT MUST NOT MEASURE ON THE SCROLL EVENT ITSELF, AND IT MUST NOT
     INTERLEAVE READS WITH WRITES. getBoundingClientRect() is a
     synchronous layout read; adding a class is a layout invalidation.
     Measure-reveal-measure-reveal down the list therefore forces a
     fresh reflow per figure, on every scroll event, which is precisely
     the stuttery scroll this whole change set exists to remove — the
     fail-open guard would have been paying for itself in jank.

     So: scroll only sets a flag, the work happens once per frame in
     rAF, and the frame does all its reading before any of its writing.
     Worst case is one layout read per figure per frame, with nothing
     invalidating layout in between. */
  var queued = false;

  function onScroll() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(sweep);
  }

  function sweep() {
    queued = false;
    var vh = window.innerHeight;
    var line = vh * RISE_LINE;
    var due = [];
    var drawDue = [];
    // Read phase — no mutation, so no forced reflow between measurements.
    for (var i = 0; i < parked.length; i++) {
      if (parked[i].getBoundingClientRect().top < line) due.push(parked[i]);
    }
    /* The charts' backstop, measured in the same read phase so it costs
       no extra reflow. Deliberately NOT the RISE_LINE test above — see
       the long note on drawOnce for why these two conditions and no
       others. */
    for (var k = 0; k < drawParked.length; k++) {
      var r = drawParked[k].el.getBoundingClientRect();
      if (r.bottom <= 0 || (r.top <= 0 && r.bottom >= vh)) drawDue.push(drawParked[k]);
    }
    // Write phase.
    for (var m = 0; m < drawDue.length; m++) drawNow(drawDue[m]);
    for (var j = 0; j < due.length; j++) reveal(due[j]);
  }

  var riseIO = (canObserve && motionOK)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) reveal(e.target);
        });
      }, { threshold: 0, rootMargin: '0px 0px -12% 0px' }) // = RISE_LINE, keep in step
    : null;

  function riseOnce(el) {
    if (!el || !riseIO) return;
    if (anyOfItVisible(el.getBoundingClientRect())) return;
    /* Parked here, not in the callback: the figure is off screen at
       this point, so the parked frame is never a frame the reader sees
       replace something she was already looking at. */
    el.classList.add('is-parked');
    parked.push(el);
    riseIO.observe(el);
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- arming a measured exhibit before it is seen ----------
     Shared by 2b and 2c, and it exists because both had the same
     stutter the claimed band had.

     THE THRESHOLD IS THE BUG. Both charts animate at 0.35, and by the
     time 35% of a tall figure has entered the viewport its top third —
     the first two or three bars — has already been on screen at its
     finished width for several hundred milliseconds. Then the callback
     fires, zeroes everything, and grows it. She watches a drawn chart
     blank itself and redraw. The old comment claiming "no flash of
     full bars" was right about the frame it was looking at and wrong
     about everything before it.

     So the zeroing moves earlier than the animation. This fires while
     the exhibit is still 400px below the fold, which is far enough
     that nothing is painted at full width and near enough that she is
     already scrolling toward it. The first frame she ever sees is 0%.

     WHAT IT COSTS, because it is a real trade against the fail-open
     rule both sections were written around: if this fires and the
     animating observer then never does, the chart sits at 0% instead
     of at its true figures. That is only reachable if she stops within
     those 400px and never scrolls the last of the way, in which case
     the chart is off screen anyway, or if the script dies between the
     two. The animating observer is attached in the same block as this
     one, so there is no path where one exists and the other does not. */
  function armOnApproach(el, zero) {
    var armIO = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { zero(); armIO.disconnect(); return; }
      }
    }, { rootMargin: '0px 0px 400px 0px', threshold: 0 });
    armIO.observe(el);
  }

  /* ---------- 2b · the symptom bars grow once ----------
     Driven from here rather than from CSS because half the animation is
     the percentage counting up, and a bar that arrives before its own
     number is worse than no animation at all. One rAF loop drives both,
     so they cannot drift apart.

     Deliberately owns no CSS: the finished widths and figures are in
     the markup, so with this file deleted, without IntersectionObserver,
     or under reduced motion, the chart is simply already drawn. Nothing
     here is a prerequisite for reading it. */

  var rank = root.querySelector('.rank');
  if (rank && canObserve && motionOK) {
    var rows = [];
    rank.querySelectorAll('.rank__row').forEach(function (row) {
      var fill = row.querySelector('.rank__fill');
      var pct = row.querySelector('.rank__pct');
      if (!fill || !pct) return;
      rows.push({
        fill: fill,
        pct: pct,
        width: parseFloat(fill.style.width),   // "79%" -> 79
        value: parseInt(pct.textContent, 10)
      });
    });

    var SHOW = 0.35; // the observer's threshold, and the skip rule

    /* Only take this over if the observer would not fire immediately
       anyway. Reloading onto a chart that is already open would
       otherwise blank it and redraw it, which reads as a glitch rather
       than a reveal. Measured against the same fraction the observer
       uses so the two can never disagree. */
    var box = rank.getBoundingClientRect();
    var onScreen = box.height > 0
      ? (Math.min(box.bottom, window.innerHeight) - Math.max(box.top, 0)) / box.height
      : 0;

    if (rows.length && onScreen < SHOW) {
      var DUR = 900;      // one bar, start to finish
      var STAGGER = 80;   // between bars, so it reads top-down
      var span = DUR + STAGGER * (rows.length - 1);

      var rowsZeroed = false;
      function zeroRows() {
        if (rowsZeroed) return;
        rowsZeroed = true;
        rows.forEach(function (r) {
          r.fill.style.width = '0%';
          r.pct.textContent = '0%';
        });
      }
      armOnApproach(rank, zeroRows);

      var rankIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          rankIO.unobserve(e.target);

          /* Idempotent, and normally already done by armOnApproach
             below while the chart was still under the fold. Called
             again here so the animation cannot start from full bars if
             the arming observer was skipped for any reason. */
          zeroRows();

          var start = 0;
          requestAnimationFrame(function step(now) {
            if (!start) start = now;
            var t = now - start;

            rows.forEach(function (r, i) {
              var p = Math.min(1, Math.max(0, (t - i * STAGGER) / DUR));
              var eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
              r.fill.style.width = (r.width * eased).toFixed(2) + '%';
              r.pct.textContent = Math.round(r.value * eased) + '%';
            });

            if (t < span) {
              requestAnimationFrame(step);
            } else {
              // Land on the real figures, never on a rounding artefact.
              rows.forEach(function (r) {
                r.fill.style.width = r.width + '%';
                r.pct.textContent = r.value + '%';
              });
            }
          });
        });
      }, { threshold: SHOW });
      rankIO.observe(rank);
    }
  }

  /* ---------- 2c · the delta bars grow once ----------
     Figure 5, on exactly the contract 2b runs: same threshold, same
     easing, same stagger, same fail-open rule. The two measured bar
     exhibits on this page are one instrument in CSS, so they animate
     as one instrument too — a reader who has seen the symptom bars
     grow should not meet a chart that snaps.

     The one real difference is the number. The rank figures are whole
     percents; these are percentage points carried to one and two
     decimals, and 2.21 must never be counted up as 2. The decimal
     count is read off the markup rather than hardcoded, so the figures
     stay owned by the HTML — change 2.21 there and the count-up
     follows.

     Owns no CSS, same as 2b. Finished widths and figures are in the
     markup: delete this file, lose IntersectionObserver, or ask for
     reduced motion, and the exhibit is simply already drawn. */

  var delta = root.querySelector('.delta');
  if (delta && canObserve && motionOK) {
    var dRows = [];
    delta.querySelectorAll('.delta__row').forEach(function (row) {
      var fill = row.querySelector('.delta__fill');
      var val = row.querySelector('.delta__val');
      if (!fill || !val) return;
      var text = val.textContent.trim();
      var dot = text.indexOf('.');
      dRows.push({
        fill: fill,
        val: val,
        width: parseFloat(fill.style.width),        // "42.5%" -> 42.5
        value: parseFloat(text),                    // "2.21"  -> 2.21
        places: dot === -1 ? 0 : text.length - dot - 1
      });
    });

    var D_SHOW = 0.35; // the observer's threshold, and the skip rule

    /* Same reason as 2b: if the chart is already open on load, leave
       it alone. Blanking and redrawing something the reader is looking
       at reads as a glitch, not a reveal. */
    var dBox = delta.getBoundingClientRect();
    var dOnScreen = dBox.height > 0
      ? (Math.min(dBox.bottom, window.innerHeight) - Math.max(dBox.top, 0)) / dBox.height
      : 0;

    if (dRows.length && dOnScreen < D_SHOW) {
      var D_DUR = 900;      // one bar, start to finish
      var D_STAGGER = 140;  // wider than 2b: two rows, and the second
                            // is the answer to the first, so it should
                            // read as a beat rather than a ripple
      var dSpan = D_DUR + D_STAGGER * (dRows.length - 1);

      var dRowsZeroed = false;
      function zeroDRows() {
        if (dRowsZeroed) return;
        dRowsZeroed = true;
        dRows.forEach(function (r) {
          r.fill.style.width = '0%';
          r.val.textContent = (0).toFixed(r.places);
        });
      }
      armOnApproach(delta, zeroDRows);

      var deltaIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          deltaIO.unobserve(e.target);

          /* Same contract as 2b: normally already zeroed by
             armOnApproach while this was still under the fold, and
             called again here as the backstop. */
          zeroDRows();

          var dStart = 0;
          requestAnimationFrame(function dStep(now) {
            if (!dStart) dStart = now;
            var t = now - dStart;

            dRows.forEach(function (r, i) {
              var p = Math.min(1, Math.max(0, (t - i * D_STAGGER) / D_DUR));
              var eased = 1 - Math.pow(1 - p, 3); // easeOutCubic, as 2b
              r.fill.style.width = (r.width * eased).toFixed(2) + '%';
              r.val.textContent = (r.value * eased).toFixed(r.places);
            });

            if (t < dSpan) {
              requestAnimationFrame(dStep);
            } else {
              // Land on the printed figures, never on a rounding artefact.
              dRows.forEach(function (r) {
                r.fill.style.width = r.width + '%';
                r.val.textContent = r.value.toFixed(r.places);
              });
            }
          });
        });
      }, { threshold: D_SHOW });
      deltaIO.observe(delta);
    }
  }

  /* ---------- 2d · the clinician quotes rise once ----------
     riseOnce, for the reason given there: these are text, and the
     hidden state must not exist in the stylesheet.

     Each card is observed separately: in the single-column layout they
     enter on different scrolls and should each rise as they arrive. In
     the two-column layout they fire together and CSS staggers the
     second — the beat is not managed from here. */

  root.querySelectorAll('.quotes .quote').forEach(riseOnce);

  /* ---------- 2e · the remaining exhibits rise once ----------
     Everything else on the page that is a figure. Before this block
     six of the eleven exhibits animated in and five snapped, which
     read as five figures that had been forgotten rather than five that
     were being held back deliberately.

     All five go through riseOnce rather than getting bespoke observers:
     the entrance beat is the only thing that differs between them and
     it belongs in CSS with the rest of each figure's design, the same
     way .fmd, .arc and .strip share drawOnce and diverge only in the
     stylesheet.

     Each one's internal sequence is its own argument, not decoration:
     the chain's spine draws down and drops its four steps in the order
     the pathway runs; the equation lands the plate, then the equals
     sign, then the capsules; the formula panel fills row by row.

     The hero image is deliberately NOT here. It is the LCP element and
     it is always on screen at load, so the skip rule above would
     decline it anyway — and fading in the first thing the reader sees
     would delay the headline's own image for no argument at all. */

  riseOnce(root.querySelector('.chain'));
  riseOnce(root.querySelector('.photo'));
  riseOnce(root.querySelector('.equation'));
  riseOnce(root.querySelector('.cutout'));
  riseOnce(root.querySelector('.formula'));

  /* ---------- 3 · Supplement Facts image ----------
     Chrome will not load a lazy image inside a hidden container, so
     force it the first time the panel opens. */

  var suppToggle = document.getElementById('bl-supp');
  if (suppToggle) {
    suppToggle.addEventListener('change', function () {
      if (!suppToggle.checked) return;
      var img = root.querySelector('.supp__img');
      if (img && img.loading === 'lazy') img.loading = 'eager';
    }, { once: true });
  }

  /* ---------- 4 · reveal the social proof ----------
     The reels and the reviews ship VISIBLE in the markup with this
     button hidden, and this hides them and shows the button. Same
     contract as the Read More control inside the reviews themselves:
     with this file deleted the reader gets everything and no control,
     which is the only acceptable direction for that failure.

     It reveals and does not toggle. A reader who has opened four
     thousand words of testimonial is not looking for a way to put them
     back, and a control that collapses the block would leave her
     scrolled to wherever it used to end. The button retires itself
     instead. */

  var social = document.getElementById('social');
  var revealBtn = document.getElementById('bl-reveal-social');

  if (social && revealBtn) {
    social.hidden = true;
    revealBtn.setAttribute('aria-expanded', 'false');

    revealBtn.addEventListener('click', function () {
      social.hidden = false;
      revealBtn.setAttribute('aria-expanded', 'true');
      revealBtn.hidden = true;

      /* Land her on the first thing revealed rather than leaving the
         viewport where a button used to be. -1 keeps it out of the tab
         order; screen readers still announce the new region instead of
         announcing nothing. */
      social.setAttribute('tabindex', '-1');
      social.focus({ preventScroll: true });
      social.scrollIntoView({ block: 'start' });
    });
  }

  /* ---------- 4d · the rating line reaches the reviews ----------
     The anchor in the markup already works on its own. This exists
     only to undo what 4 does: the social block ships visible and 4
     hides it behind a reveal button, so #reviews has no box and the
     fragment lands nowhere. The script broke the link, so the script
     repairs it.

     It presses 4's own button rather than unhiding the block directly,
     so the reveal keeps its aria-expanded bookkeeping and its button
     still retires itself. That button then lands her on the first
     thing revealed, which is the reels; scrolling to #reviews
     afterwards overrides it, because she asked for the reviews and not
     for the videos above them. */
  (function () {
    var jump = root.querySelector('.ratingbar__jump');
    if (!jump) return;

    jump.addEventListener('click', function (e) {
      var target = document.getElementById('reviews');
      if (!target) return;            /* let the href do what it can */
      e.preventDefault();

      var block = document.getElementById('social');
      var btn = document.getElementById('bl-reveal-social');
      if (block && block.hidden) {
        if (btn && !btn.hidden) { btn.click(); } else { block.hidden = false; }
      }

      target.scrollIntoView({ block: 'start' });
    });
  })();

  /* ---------- 4 · the strip gate ----------
     The beat between a door and the offer: she develops a test strip,
     reads it against the printed scale, and goes through to the sheet
     from the result. Markup and rationale are in index.html at
     #strip-gate — including why this is a strip and not a scratchcard.

     THIS RUNS BEFORE 4a AND THAT IS AN ORDERING DEPENDENCY. On a
     second door press the gate is skipped by repointing every door's
     popovertarget back to the sheet, and 4a collects its doors with a
     [popovertarget="offer-sheet"] query at init. Repointing after that
     query would produce doors the sheet section has never seen, which
     silently drops data-sheet-to — the "open the sheet at this
     section" hook. Move this below 4a and that breaks with no error.

     WHAT SURVIVES THIS FILE BEING DELETED. All of it, degraded: the
     doors are plain popovertarget="strip-gate" buttons and the gate's
     CTA is a plain popovertarget="offer-sheet" button, so the whole
     path still walks. She gets a strip that is already developed (the
     CSS default) and the gate every time rather than once. Nothing
     here gates the offer; it only animates the way to it. */

  /* THE HANDOFF FLAG, and it has to live out here because the two
     halves of the moment are in two different sections. The gate (§4)
     knows she pressed Claim it; the sheet (§4a) knows when it has
     finished sliding in. This carries the one bit between them.

     WHY A FLAG AND NOT "THE FIRST OPEN". The gate is once per session,
     so on a second page load in the same session every door goes
     straight to the sheet and the first open of this load is NOT a
     claim. Celebrating that one would congratulate her for pressing
     a door. Only the gate's own CTA sets this. */
  var claimLanding = false;

  (function () {
    var gate = document.getElementById('strip-gate');
    var strip = document.getElementById('gate-strip');
    var go = gate && gate.querySelector('.gate__go');
    var gateSheet = document.getElementById('offer-sheet');
    if (!gate || !strip || !go || !gateSheet) return;

    var SEEN = 'bl-strip-gate';

    /* sessionStorage throws outright in some privacy modes rather than
       failing soft, so every touch of it is wrapped. Losing the flag
       costs one repeat of the gate; an uncaught throw here would take
       out everything below it in this file. */
    function seen() {
      try { return sessionStorage.getItem(SEEN) === '1'; } catch (e) { return false; }
    }
    function markSeen() {
      try { sessionStorage.setItem(SEEN, '1'); } catch (e) {}
    }

    /* ONCE PER SESSION, and this is the part that decides whether the
       gate is charming or infuriating. There are four doors and a
       sticky bar on this page, all pointed here, and a reader who
       meets the same demonstration on the fourth
       one is being made to pay for the same trick four times. After the
       first close — completed, skipped or Esc'd, it does not matter
       which — every door goes straight to the sheet. */
    var doors = [];
    root.querySelectorAll('[popovertarget="strip-gate"]').forEach(function (d) {
      if (d.classList.contains('gate__skip')) return;   /* the way out, not a way in */
      doors.push(d);
    });

    function bypass() {
      doors.forEach(function (d) { d.setAttribute('popovertarget', 'offer-sheet'); });
    }

    if (seen()) { bypass(); return; }

    /* .is-armed is the whole no-JS contract in one class: CSS ships the
       developed pad and a visible result, and this resets both. Added
       only once we know we are going to run the gate, so a bail-out
       above here can never leave her looking at a blank strip. */
    gate.classList.add('is-armed');
    gate.style.setProperty('--dev', '0');

    var verdict = gate.querySelector('.gate__verdict');
    var say = document.getElementById('gate-say');
    var prize = gate.querySelector('.gate__prize-num');
    var price = gate.querySelector('.gate__prize-price');
    var verdictText = verdict ? verdict.textContent.trim() : '';

    /* The live region announces BOTH beats in one utterance. A screen
       reader user gets no fade and no stamp, so the only way she learns
       the reveal carried a discount is if the words say so. Read out of
       the markup, never written here, so the two never drift apart. */
    var sayText = verdictText;
    if (prize) sayText += ' ' + prize.textContent.trim() + '.';

    /* THE STRUCK PRICE IS EXCLUDED, and that is the whole reason this
       is not just another textContent read. .gate__prize-price prints
       "$48.00 $59.99" with the second one inside <s>, and the strike is
       what carries the meaning. Flattened into a live region it
       announces as two prices in a row with nothing to say which is
       which, and the last number wins — so she hears the discount
       reveal quote her the UNDISCOUNTED price. Announce the payable one
       and stop. The full pair is still in the DOM, in reading order,
       for anyone who navigates to it. */
    if (price) {
      var payable = price.firstChild && price.firstChild.nodeValue;
      if (payable && payable.trim()) sayText += ' ' + payable.trim() + '.';
    }

    /* ---- the develop ---- */

    /* ONE PIXEL OF THUMB, ONE PIXEL OF COLOUR. The drag distance for a
       full pad IS the pad's height: the ink front is then exactly where
       her thumb is, which is the whole claim the gesture makes. It was
       150 against a 46px pad — a 3:1 mapping, so the colour crawled a
       third of the distance her hand travelled and the strip felt like
       a progress bar she was charging from a distance rather than a
       thing she was wiping.

       MEASURED, NOT COPIED. This used to be a hard-coded 84 with a
       comment at each end asking whoever touched one to remember the
       other, and the pad is now two different heights across a
       max-height breakpoint, so the copy could not have stayed right
       anyway. Reading the box keeps the mapping exact on both, and on
       any future breakpoint, for free.

       IT IS READ ON POINTERDOWN, NOT AT INIT. The gate is a popover, so
       it is display:none until it opens and every box in it measures 0
       — a value taken here would be a permanent divide-by-nothing. By
       the time a finger is down the pad is laid out and the number is
       true for this gesture, including after an orientation change. The
       fallback is the desktop height, for the one case where the
       element is somehow unmeasurable. */
    var pad = gate.querySelector('.gate__pad');
    var TRAVEL = 42;           /* px of drag for a full pad — refreshed from .gate__pad */

    function measure() {
      if (!pad) return;
      var h = pad.getBoundingClientRect().height;
      if (h > 0) TRAVEL = h;
    }
    var dev = 0;
    var read = false;
    var dragging = false;
    var startY = 0;
    var startDev = 0;
    var raf = 0;
    var safety = 0;
    var viaPointer = false;
    var band = '';

    /* HAPTICS WHERE THERE ARE ANY. Android Chrome fires these; iOS
       Safari has never implemented the Vibration API, so on an iPhone
       every call below is a no-op and the surface has to work without
       them — which is why the press state, the wet edge and the ring
       are all visual. Treat this as a bonus on the devices that have
       it, never as load-bearing. Some engines throw on a gesture-less
       call rather than returning false, hence the wrap. */
    function buzz(pattern) {
      if (!motionOK) return;   /* reduced motion means reduced everything */
      try { if (navigator.vibrate) navigator.vibrate(pattern); } catch (e) {}
    }

    /* The marker rides to 62% of the bar and the legend is three equal
       columns, so the word it is standing over changes at the thirds.
       Kept as one derived value rather than duplicated thresholds: if
       the marker's 62% moves in the CSS, move it here too. */
    function bandAt(v) {
      var pct = v * 62;
      return pct < 33.34 ? 'low' : pct < 66.67 ? 'target' : 'high';
    }

    function paint(v) {
      gate.style.setProperty('--dev', v.toFixed(4));
      var b = bandAt(v);
      if (b === band) return;
      /* Under her thumb only. The same crossing happens again during
         the release animation and once more at finish(); buzzing on
         those would rattle at the reader instead of answering her. */
      if (band && dragging) buzz(10);
      band = b;
      gate.setAttribute('data-band', b);
    }

    paint(0);   /* seeds data-band so the legend lights before she starts */

    function finish() {
      read = true;
      dev = 1;
      cancelAnimationFrame(raf);
      clearTimeout(safety);
      paint(1);
      gate.classList.remove('is-held');
      gate.classList.add('is-read');
      buzz([16, 46, 26]);   /* two taps: the strip settling, then the reading */

      /* AND A THIRD, ON THE PRIZE. It fires at the delay the CSS gives
         .gate__prize, so the phone answers at the moment the discount
         lands rather than at the moment the colour stops. Two separate
         events deserve two separate taps; one buzz covering both makes
         the reward feel like a footnote to the reading. */
      setTimeout(function () { buzz(22); }, 440);

      /* AND THE PAYOFF IS BROUGHT TO HER IF IT IS OFF SCREEN. The
         reveal is at the top of the gate and the prize and its button
         are at the bottom, so on a short phone (an SE has roughly
         550px of usable height against ~650px of gate) she develops
         the strip, wins the discount, and the button that spends it is
         under the fold behind a scroll she has no reason to believe in.
         The CSS at max-height:760px buys most of that back; this
         guarantees the rest at any height.

         AFTER the prize has landed, never before: scrolling during the
         develop would pull the strip out from under her thumb. And
         only if it is actually clipped, so on a tall screen nothing
         moves at all. */
      setTimeout(function () {
        if (go.getBoundingClientRect().bottom <= gate.clientHeight) return;
        /* Smooth only when there is something to be smooth ON. A
           hidden tab does not composite, so a smooth scroll queued
           there can simply never advance and she comes back to the
           button still off screen — the same failure the rAF safety
           net above exists for. Jump-cut it instead; she is not
           watching. */
        var how = (motionOK && !document.hidden) ? 'smooth' : 'auto';
        try {
          go.scrollIntoView({ block: 'nearest', behavior: how });
        } catch (e) { go.scrollIntoView(false); }
      }, 560);

      /* Announce by writing the verdict into the hidden live region —
         see the note on #gate-say in the markup for why it is not the
         visible one. The words are read out of the markup rather than
         written here, so there is one place to edit them and the no-JS
         reader is never shown copy this file invented. */
      if (say) say.textContent = sayText;

      /* FOCUS MOVES FOR THE KEYBOARD ONLY. Landing focus on the CTA
         makes Enter, Enter walk the whole gate — but a programmatic
         focus after a thumb-drag paints a focus ring on the button for
         a reader who never touched a key, and on this surface that ring
         is the loudest thing on screen. She got the result visually;
         she does not need the browser to shout about the button. */
      if (!viaPointer) {
        try { go.focus({ preventScroll: true }); } catch (e) { go.focus(); }
      }
    }

    /* RELEASING ALWAYS COMPLETES IT, from any distance, and a plain
       press completes it from zero. There is deliberately no threshold
       to clear: a drag that snaps back because she did not pull far
       enough turns a toy into a task she can fail, and the thing she
       would have failed at is a demonstration we asked her to watch.
       The drag is direct manipulation for its own sake — the colour
       follows her thumb — and the release just finishes the sentence. */
    function commit() {
      if (read) return;
      if (!motionOK) { finish(); return; }

      var from = dev;
      var ms = Math.max(280, (1 - from) * 900);
      var t0 = 0;

      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function step(t) {
        if (!t0) t0 = t;
        var p = Math.min(1, (t - t0) / ms);
        var eased = 1 - Math.pow(1 - p, 3);          /* easeOutCubic */
        var v = from + (1 - from) * eased;
        if (p < 1) { paint(v); raf = requestAnimationFrame(step); }
        else finish();
      });

      /* THE ANIMATION IS NOT ALLOWED TO BE THE ONLY THING THAT CAN
         FINISH THIS. requestAnimationFrame does not run in a
         backgrounded tab, so a reader who releases the strip and
         immediately switches app leaves the develop parked wherever her
         thumb stopped — and she comes back to a half-coloured pad, no
         result and no button through to the offer. Observed, not
         theorised: it is the state this surface sat in on every test
         run where the window was not frontmost.

         setTimeout is throttled in a hidden tab but it still fires, so
         this lands her on the finished state either way. Idempotent —
         finish() through the normal path makes this a no-op. */
      clearTimeout(safety);
      safety = setTimeout(function () { if (!read) finish(); }, ms + 250);
    }

    strip.addEventListener('pointerdown', function (e) {
      if (read) return;
      e.preventDefault();                    /* no text selection, no native image drag */
      viaPointer = true;
      dragging = true;
      measure();                             /* the pad is laid out now; see TRAVEL */
      startY = e.clientY;
      startDev = dev;
      gate.classList.add('is-touched');      /* kills the invitation, permanently */
      gate.classList.add('is-held');         /* the strip takes the press */
      buzz(8);                               /* answer the finger before it has done any work */
      cancelAnimationFrame(raf);
      try { strip.setPointerCapture(e.pointerId); } catch (err) {}
    });

    strip.addEventListener('pointermove', function (e) {
      if (!dragging || read) return;
      var v = startDev + (e.clientY - startY) / TRAVEL;
      dev = v < 0 ? 0 : v > 1 ? 1 : v;
      paint(dev);
      if (dev >= 1) { dragging = false; commit(); }
    });

    function release() {
      gate.classList.remove('is-held');
      if (!dragging) return;
      dragging = false;
      commit();
    }
    strip.addEventListener('pointerup', release);
    strip.addEventListener('pointercancel', release);

    /* Keyboard and assistive tech land here — the strip is a real
       button, so Enter and Space fire click and it develops over the
       full 900ms from zero. Mouse and touch reach this too, after
       pointerup has already committed; commit() is idempotent. */
    strip.addEventListener('click', function () {
      gate.classList.add('is-touched');
      commit();
    });

    /* ---- through to the offer ---- */

    /* THE ATTRIBUTE IS REMOVED RATHER THAN LEFT TO FIGHT THIS HANDLER.
       In the markup this button is a plain popovertarget so the path
       works with this file deleted — but a popover invoked from inside
       another popover is NESTED (see the note on the sheet), so the
       native path opens the sheet on top of a gate that stays open
       underneath it, and the sheet's back chevron would then land her
       on the gate instead of the article. Showing the sheet from
       script instead makes them ordinary siblings, so the browser
       light-dismisses the gate on its own. Do not put the attribute
       back and hope preventDefault holds it. */
    go.removeAttribute('popovertarget');
    go.addEventListener('click', function () {
      markSeen();
      bypass();
      /* Set BEFORE the sheet opens. showPopover() fires the toggle
         event synchronously, so anything set after this line is set
         after the handler that reads it has already run. */
      claimLanding = true;
      gateSheet.showPopover();
      if (gate.matches(':popover-open')) gate.hidePopover();   /* if it did not go on its own */
    });

    /* ---- scroll lock, and the handoff ---- */

    gate.addEventListener('toggle', function (e) {
      if (e.newState === 'open') {
        document.documentElement.style.overflow = 'hidden';
        return;
      }
      markSeen();
      bypass();
      /* The sheet runs its own lock. On the way through, this close and
         that open both fire, and clearing the lock unconditionally
         would leave the article scrolling behind a fully open sheet. */
      if (!gateSheet.matches(':popover-open')) {
        document.documentElement.style.overflow = '';
      }
    });
  })();

  /* ---------- 4a · the offer sheet ----------
     OPENING AND CLOSING IT IS NOT DONE HERE. Every way in is a <button
     popovertarget>, so the browser owns the open, the close, Esc, light
     dismiss, focus and inertness. With this file deleted the sheet
     still works — it just does not lock the page behind it and the
     second closing button lands at the top instead of on the reviews.
     Both are degradations, neither is a break.

     WHERE THE DOORS POINT NOW. Since the strip gate (§4) the four
     doors and the sticky bar open #strip-gate first and the sheet is
     opened from the gate's own CTA. The labels differ since 13 Aug and
     none of this reads them: everything here is keyed on
     popovertarget, so relabelling a door cannot break the routing, and
     the earliest slot dropping out of the set (it is now a link to
     #fmd) simply removes it from the query.
     §4 repoints them straight back here once
     she has met the gate, and it does that BEFORE the query below runs
     so they are collected either way — see the ordering note there.

     SCROLL LOCK. Without it the article scrolls under the sheet on
     every wheel and trackpad gesture, and closing it drops her
     somewhere she never chose. overscroll-behavior:contain on the
     scroller stops touch scroll chaining; this stops the rest. Known
     limit: overflow:hidden on <html> is not a complete lock in iOS
     Safari. The usual fix is position:fixed on <body>, which costs the
     scroll position and a visible jump on close — worse than the
     symptom on a full-viewport sheet like this one. Revisit only if it
     is actually observed on a device.

     WHY THE TARGET IS RECORDED ON CLICK. There is one sheet and two
     places to land in it, and the popover API has no notion of
     "open at". The click handler records where this particular door
     wanted to go, and the toggle handler spends it. Recording on click
     rather than reading the event target inside toggle matters because
     toggle also fires for Esc, light dismiss and the close button,
     none of which have a door attached. */

  var sheet = document.getElementById('offer-sheet');
  var sheetScroll = document.getElementById('sheet-scroll');

  if (sheet) {
    var sheetTarget = null;
    var awardFixed = false;

    /* THE FRONTROWMD BADGE HAS TO BE RELOADED ONCE THE SHEET IS OPEN,
       and this is not optional — VERIFIED BROKEN WITHOUT IT.

       Their widget is a cross-origin iframe that measures its own
       content and posts the height out to window.resizeHeight(), which
       their script installs. A cross-origin iframe inside a
       display:none container never lays out, so the height it reports
       on first load is 0 and the badge renders as an empty grey block
       for the entire session. Measured: 131px on the old in-scroll
       page, 0px inside the closed sheet, 131px again after this
       reload.

       Re-assigning src re-runs their whole handshake while the
       container is visible. Once only, on first open — doing it on
       every open would flash the badge out and back in each time she
       opens the sheet, and the height is already correct by then.

       .convert__award reserves 131px, so even if this fails (their
       script blocked, offline, ad blocker) the layout does not shift
       and nothing below it moves under her thumb. */
    function fixAward() {
      if (awardFixed) return;
      var frame = root.querySelector('.iframe-frontrow');
      if (!frame) return;
      awardFixed = true;
      frame.src = frame.src;
    }

    /* ---- the claimed band lands ----
       The offer used to open on a product shot, so the discount she
       had just won disappeared at the moment she arrived to spend it.
       #claimed is the acknowledgement and it ships filled and legible;
       this is only the arrival, and it runs at most once per session.

       IT WAITS FOR THE SLIDE TO FINISH. The sheet's push is 320ms of
       full-viewport horizontal travel and a flood animating underneath
       it is a flood nobody sees — worse, it competes with the travel
       and the whole arrival reads as jitter. 360ms lands it just after
       the surface has settled, which is also the beat where a native
       push hands over. IF THE 0.32s TRANSITION ON .sheet CHANGES,
       CHANGE THIS.

       REDUCED MOTION SKIPS THE CLASS ENTIRELY rather than being handled
       inside it. The band's resting state is its base rule, so doing
       nothing here is already the correct output — she gets the plum,
       the tick and the price, just without the reveal. The @media in
       styles.css is the belt to this braces; both are deliberate,
       because the buzz below is gated on the same preference and only
       this side can see it.

       NO HAPTIC ON A SURFACE SHE IS NOT LOOKING AT. document.hidden
       means she has switched app between pressing Claim it and the
       sheet arriving, and a phone that buzzes in her pocket about a
       discount is the single most irritating thing this page could do.
       The class is still added; the animation just runs unwatched, and
       the band is in its resting state by the time she is back. */
    var claimed = document.getElementById('claimed');
    var claimLanded = false;

    function landClaim() {
      if (!claimLanding) return;
      claimLanding = false;
      if (!claimed || claimLanded || !motionOK) return;
      claimLanded = true;

      /* THE CLASS GOES ON NOW AND THE WAIT LIVES IN CSS, and swapping
         those two around is the whole fix for a visible stutter.

         This used to add .is-landing inside a 360ms setTimeout. For
         those 360ms the band sat in its resting state — full plum,
         words, tick, all legible — and then the class landed and
         animation-fill-mode: both snapped every element back to its
         from-values to start the reveal. So she watched the finished
         band appear, vanish, and rebuild itself. The band was correct
         at both ends and wrong in the middle, which is why it read as
         a glitch rather than a bug.

         Adding the class immediately and delaying each animation in
         CSS gives the same choreography with no flash: `both` applies
         the from-values through the delay, so the band is in its
         pre-reveal state from the first frame the sheet is open.

         THE 360ms STILL EXISTS, it just lives in styles.css now, on
         every one of the five delays. It waits out the sheet's 0.32s
         push, because a flood animating under a moving screen is a
         flood nobody sees. IF THAT TRANSITION CHANGES, the delays in
         styles.css change with it. */
      claimed.classList.add('is-landing');

      setTimeout(function () {
        /* One tap, on the flood, not on the tick. It answers the press
           she just made rather than punctuating an animation she can
           already see. iOS has no Vibration API, so this is a no-op on
           an iPhone and nothing here may depend on it. */
        if (document.hidden) return;
        try { if (navigator.vibrate) navigator.vibrate(18); } catch (e) {}
      }, 360);
    }

    root.querySelectorAll('[popovertarget="offer-sheet"]').forEach(function (door) {
      door.addEventListener('click', function () {
        sheetTarget = door.getAttribute('data-sheet-to');
      });
    });

    sheet.addEventListener('toggle', function (e) {
      var open = e.newState === 'open';
      document.documentElement.style.overflow = open ? 'hidden' : '';

      if (!open) { sheetTarget = null; return; }

      fixAward();
      landClaim();

      if (!sheetScroll) { sheetTarget = null; return; }

      /* The sheet keeps its scroll position between opens, so every
         open resets it. Measured as the DIFFERENCE between two rects
         inside the same container, which is why it is correct even
         though this fires while the open transition is still running:
         the transform applies to both elements equally and cancels. */
      var dest = sheetTarget && document.getElementById(sheetTarget);
      if (dest) {
        sheetScroll.scrollTop +=
          dest.getBoundingClientRect().top - sheetScroll.getBoundingClientRect().top;
      } else {
        sheetScroll.scrollTop = 0;
      }
      sheetTarget = null;
    });
  }

  /* ---------- 4c · arriving on #offer ----------
     "Skip to the kit" on the quiz sends her here with #offer on the
     URL, and until now that did nothing at all.

     #offer is div.convert, and div.convert lives INSIDE the offer
     sheet. A closed popover is display:none, so the fragment points at
     an element with no box and the browser has nowhere to scroll to.
     She landed at the top of a nine-minute article having just pressed
     a button that promised to skip it.

     Pressing a real door rather than opening the sheet directly, and
     that is deliberate. The doors already know whether this session
     has met the strip gate: 4 swaps their popovertarget to the sheet
     after the first close, so one synthetic click inherits the gate,
     the bypass and the sheet without duplicating any of that logic
     here. Open the sheet directly and a first-time reader skips the
     gate she was meant to meet, and only when she arrives by this one
     route.

     The inline doors only. .act scopes this to the ones in the article
     body; the sticky bar is not inside one, and neither is the gate's
     own way out.

     This sits after 4a on purpose. Opening a popover fires toggle
     synchronously, and 4a is what listens for it. */
  (function () {
    if (location.hash !== '#offer') return;
    var door = root.querySelector('.act [popovertarget]');
    if (!door) return;
    door.click();
  })();

  /* ---------- 4b · subscription delivery frequency ----------
     Showing and hiding the picker is pure CSS (:checked siblings).
     This only copies the chosen option's data-* onto the price, the
     billing line and the two contents rows, swaps the product shot for
     one whose label prints the matching count, and stamps the variant
     and selling plan onto the CTA so section 6 adds the right thing.

     Nothing is gated behind it: without JS the select still renders and
     the markup's default 3-month figures stay correct. */

  (function () {
    var sel = document.getElementById('bl-freq');
    if (!sel) return;

    var out = {
      price: document.getElementById('bl-sub-price'),
      billed: document.getElementById('bl-sub-billed'),
      caps: document.getElementById('bl-sub-caps'),
      strips: document.getElementById('bl-sub-strips')
    };
    var buy = document.getElementById('bl-cta-sub');
    var img = document.getElementById('bl-sub-img');
    var base = sel.getAttribute('data-href');

    function apply() {
      var opt = sel.options[sel.selectedIndex];
      if (!opt) return;

      Object.keys(out).forEach(function (k) {
        var v = opt.getAttribute('data-' + k);
        if (out[k] && v) out[k].textContent = v;
      });

      if (buy) {
        // The href is the no-JS fallback and stays the PDP; the data-*
        // pair is what addSubscription() actually posts to cart/add.js.
        if (base) buy.href = base + '?freq=' + opt.value;
        buy.setAttribute('data-variant', opt.getAttribute('data-variant') || '');
        buy.setAttribute('data-selling-plan', opt.getAttribute('data-selling-plan') || '');
      }

      // The shot has to match the count printed on the label.
      var src = opt.getAttribute('data-img');
      if (img && src && img.getAttribute('src') !== src) {
        img.src = src;
        img.alt = opt.getAttribute('data-alt') || '';
      }
    }

    sel.addEventListener('change', apply);
    apply();
  })();

  /* ---------- 5 · UGC reels ----------
     The markup ships native controls and no autoplay, which is the
     no-JS state: a paused video the reader can start herself. Here we
     take over, because a scrub bar and an overflow menu are the wrong
     vocabulary for a testimonial.

     Playback is muted, looping and only while on screen. Unmuting one
     mutes the others, since two testimonials talking over each other
     is nobody's idea of proof. */

  (function () {
    var items = root.querySelectorAll('.reels__item');
    if (!items.length) return;

    var videos = [];
    items.forEach(function (item) {
      var v = item.querySelector('.reels__video');
      if (!v) return;
      var muteBtn = item.querySelector('[data-reel-mute]');
      var playBtn = item.querySelector('[data-reel-play]');
      videos.push(v);

      v.removeAttribute('controls');
      v.muted = true;
      v.playsInline = true;

      if (muteBtn) {
        muteBtn.addEventListener('click', function () {
          var unmuting = v.muted;
          if (unmuting) {
            videos.forEach(function (other) {
              if (other === v) return;
              other.muted = true;
              var b = other.parentNode.querySelector('[data-reel-mute]');
              if (b) { b.classList.remove('is-on'); b.setAttribute('aria-label', 'Unmute video'); }
            });
          }
          v.muted = !unmuting;
          muteBtn.classList.toggle('is-on', unmuting);
          muteBtn.setAttribute('aria-label', unmuting ? 'Mute video' : 'Unmute video');
          if (unmuting && v.paused) v.play().catch(function () {});
        });
      }

      if (playBtn) {
        playBtn.addEventListener('click', function () {
          if (v.paused) { v.play().catch(function () {}); } else { v.pause(); }
        });
        v.addEventListener('play', function () {
          playBtn.classList.remove('is-paused');
          playBtn.setAttribute('aria-label', 'Pause video');
        });
        v.addEventListener('pause', function () {
          playBtn.classList.add('is-paused');
          playBtn.setAttribute('aria-label', 'Play video');
        });
      }
    });

    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (v) { v.play().catch(function () {}); });
      return;
    }

    var rio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          v.play().catch(function () {});
        } else {
          v.pause();
          v.muted = true;
          var b = v.parentNode.querySelector('[data-reel-mute]');
          if (b) { b.classList.remove('is-on'); b.setAttribute('aria-label', 'Unmute video'); }
        }
      });
    }, { threshold: 0.55 });
    videos.forEach(function (v) { rio.observe(v); });
  })();

  /* ---------- 6 · subscription add-to-cart ----------
     The subscription MUST go through /cart/add.js with its
     selling_plan id. A plain cart permalink silently drops the
     selling plan and charges the one-time price on every bottle, so
     do not "simplify" this back to an href. The href in the HTML is
     the no-JS fallback and points at the PDP. */

  function addSubscription(e) {
    var link = document.getElementById('bl-cta-sub');
    if (!link) return;
    var variant = link.getAttribute('data-variant');
    var plan = link.getAttribute('data-selling-plan');
    if (!variant || !plan) return; // fall through to the href

    e.preventDefault();
    var btn = e.currentTarget;
    var original = btn.textContent;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      /* THE ATTRIBUTE IS A HANDLE FOR THE CHECKOUT, which is the one
         surface this page cannot reach. Nothing here runs on
         /checkout, so a checkout upsell cannot be suppressed from the
         landing page — it has to be a rule inside the app that draws
         it, and a rule needs something on the cart to key off.

         Aftersell is installed and puts a "Unleash Your True Potential"
         block in the checkout offering Nitric Oxide Support 180ct at
         15% off. That is the same product this button sells at 30% off
         on a subscription, so at the moment of purchase the checkout
         undercuts the page's own offer, and taking it swaps a
         subscription for a one-time order.

         Product targeting cannot tell "she came from this page" from
         "she bought the same product elsewhere". A cart attribute can.
         Exclude carts where _lp is women-curve in the app's funnel
         conditions and nothing changes store-wide.

         The underscore prefix is Shopify's convention for a private
         attribute: it stays out of the order confirmation and the
         packing slip, so the customer never sees it.

         It is harmless if the app cannot read it. The cost is one key
         on a JSON body; the value is that any future checkout rule has
         something to aim at. */
      body: JSON.stringify({
        items: [{ id: Number(variant), quantity: 1, selling_plan: Number(plan) }],
        attributes: { '_lp': 'women-curve' }
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/add failed: ' + r.status);
        window.location.href = '/checkout';
      })
      .catch(function () {
        // Never strand the click. Send them to the PDP instead.
        btn.textContent = original;
        window.location.href = link.getAttribute('href');
      });
  }

  var subCta = document.getElementById('bl-cta-sub');
  if (subCta) subCta.addEventListener('click', addSubscription);

  /* The sticky bar used to be a second checkout path — it swapped into
     the live plan CTA past the offer block and called this directly.
     It opens the sheet now, so the subscription posts from exactly one
     button on the page. Do not wire a buy back onto the sticky bar
     without also solving the sync problem that removing it solved.
     The bar reintroduced in §7 is a plain popovertarget button and
     touches none of this. */

  /* ---------- 7 · the sticky door ----------
     The bar is up only where no other way in is on screen. Markup and
     the reasoning for its shape are at #bl-sticky in index.html; this
     is the "when".

     TWO CONDITIONS, AND BOTH HAVE TO HOLD:

       1. She is past the FIRST door. Not "has scrolled 20%", not "is
          past the fold" — past the specific element that first offered
          her the offer. Before that point the page has not asked for
          anything yet and a bar is the page interrupting its own
          opening argument, which is the whole reason the old one was
          cut.

       2. No door is currently on screen. A bar floating over a door
          is two identical buttons in one viewport, and the fixed one
          steals the press from the one the section actually earned.

     The DSHEA box is watched alongside the doors, for a third reason:
     it is a required disclosure and a bar parked over it is the one
     overlap on this page that is a compliance problem rather than a
     taste problem. On a short viewport at the very bottom it is the
     element most likely to be under the bar, so it hides it too.

     STATE IS MEASURED, NOT ACCUMULATED, AND THE FIRST VERSION OF THIS
     GOT IT WRONG. It tracked everything from IntersectionObserver
     entries alone: a set of currently-intersecting elements, and
     "past" read off the entry for the first door. That is wrong for a
     reason worth writing down, because it is the standard IO trap.

     IO ONLY DELIVERS AN ENTRY WHEN THE INTERSECTION STATE CHANGES. A
     door below the viewport and a door above the viewport are the same
     state — not intersecting. So any jump that carries the first door
     from below the screen to above it in one go produces NO entry at
     all, and "past" stays false forever. Verified in the browser: an
     instant scroll from the top to mid-article left the bar down for
     the rest of the session. It is not a synthetic case either. An
     anchor link, a restored scroll position on reload, and a hard flick
     on a phone all do exactly that.

     So the observer is kept as a TRIGGER and not as the source of
     truth. Anything that fires it — and it fires on layout change,
     which is the thing a scroll listener alone would miss — schedules
     a measurement, and the measurement reads live rects for every
     watched element. Scroll and resize schedule the same measurement.
     The three inputs cannot disagree because none of them carries any
     state; they only say "look again".

     WHAT THE OBSERVER IS ACTUALLY BUYING, since it is no longer doing
     the arithmetic: the social proof block ships hidden and is revealed
     by §4, which brings a fifth door into the layout with no scroll and
     no resize. IO notices. A scroll listener on its own would need §4
     to remember to poke it, and would rot the first time something else
     changed the layout.

     COST. Six getBoundingClientRect calls, at most one per animation
     frame, and only while something is moving. That is not a budget
     worth optimising against, and the alternative was a bug.

     WITH NO INTERSECTIONOBSERVER the bar never comes up. That is the
     correct failure: the four inline doors are the page's actual
     contract and the bar is an addition to it, so losing the addition
     costs nothing. Same reason it also bails when there are no doors
     to watch. */

  (function () {
    var bar = document.getElementById('bl-sticky');
    if (!bar || !canObserve) return;

    /* THE ARTICLE'S OWN DOORS, NOT THE PAGE'S. Merged, the quiz sits
       inside #bl-lp too and its panels carry three .act blocks of their
       own: both Continue buttons and the result's door. Collected
       together with the article's, doors[0] is Q1's Continue, "past the
       first door" is true the moment she answers question one, and the
       bar rises 2,700px before the article's first real door — over the
       opening argument, which is the single thing the old bar was cut
       for. Measured, not guessed: it came up at scrollY 2000 with the
       first article door still below the fold.

       Standalone the container does not exist and the scope is the
       whole page, exactly as before. */
    var scope = document.getElementById('bl-article') || root;

    /* In-flow doors only. Same rule as the DSHEA box below: anything
       inside the sheet is in the top layer when it matters and cannot
       be overlapped by this bar, so it is not evidence about whether
       the reader currently has a way in.

       THE FIRST .act IS THE SCROLL CUE SINCE 13 AUG, not a door, and
       it is deliberately still counted twice over. It is doors[0], so
       the bar still waits for that slot to leave the screen before it
       may come up at all, which is the behaviour this had when the
       slot was a door and the right one: that slot is where the
       article first offers her a way forward. And it still blocks,
       because a floating bar landing next to it would put two
       competing controls in one screen, which is the exact stacking
       this whole section exists to prevent. */
    var doors = [];
    scope.querySelectorAll('.act').forEach(function (d) {
      if (!d.closest('.sheet')) doors.push(d);
    });
    if (!doors.length) return;

    /* THE ARTICLE'S BOX, NOT THE SHEET'S, and it is selected by where
       it is rather than by being first. There are two .dsheabox
       elements and the article's happens to come first in the markup
       today, so a bare querySelector would work and would break
       silently the day anything is added above the sheet. The sheet is
       a popover in the top layer; nothing inside it can ever be
       overlapped by a bar behind it, so it is excluded by rule. */
    var foot = null;
    scope.querySelectorAll('.dsheabox').forEach(function (box) {
      if (!foot && !box.closest('.sheet')) foot = box;
    });

    var first = doors[0];
    var watch = foot ? doors.concat([foot]) : doors;

    /* A zero-area rect is a display:none element, which is how the
       hidden social block's door reports before §4 reveals it. Without
       this it measures as a 0x0 box at the top left of the document,
       which is "on screen" for anyone scrolled to the top and would
       hold the bar down over the whole article. */
    function onScreen(el) {
      var r = el.getBoundingClientRect();
      if (!r.width && !r.height) return false;
      return r.bottom > 0 && r.top < (window.innerHeight ||
        document.documentElement.clientHeight);
    }

    function measure() {
      pending = false;

      /* <= 0, so the door counts as passed at the exact moment its last
         pixel leaves the top of the screen and not a frame later. The
         same comparison decides "not on screen" in onScreen above, so
         the two can never both be true and flicker the bar.

         A ZERO-AREA RECT IS A DOOR THAT IS NOT RENDERED, AND YOU CANNOT
         WALK PAST A DOOR THAT IS NOT THERE. display:none reports every
         edge as 0, so the bare comparison reads bottom <= 0 as true and
         decides she is past the first door before the article exists.
         Merged, the article ships hidden until she answers, so that put
         a conversion bar over question one — an offer for a page she
         had not been shown yet.

         onScreen below already guards the same way and for the same
         reason, which is what made this findable: two rules reading the
         same rect and only one of them treating "no box" as "no". */
      var fr = first.getBoundingClientRect();
      var past = (fr.width || fr.height) ? fr.bottom <= 0 : false;

      var blocked = false;
      for (var i = 0; i < watch.length; i++) {
        if (onScreen(watch[i])) { blocked = true; break; }
      }

      bar.classList.toggle('is-up', past && !blocked);
    }

    /* rAF IS THE THROTTLE, AND A HIDDEN TAB HAS NO FRAMES. The point of
       deferring to a frame is to keep six rect reads off the scroll
       handler's critical path, and in a background tab there is no
       painting to protect — requestAnimationFrame simply never fires
       there, so a queued measurement would sit unrun and the bar would
       be in a stale state the moment she came back to the tab.

       Measuring inline when the page is hidden costs nothing (nothing
       is being drawn) and means the two paths agree. Found while
       testing this: an automated browser holds the tab hidden, no frame
       ever came, and the bar never moved despite the logic being
       right. */
    var pending = false;
    function schedule() {
      if (document.hidden) { measure(); return; }
      if (pending) return;
      pending = true;
      requestAnimationFrame(measure);
    }

    var io = new IntersectionObserver(schedule);
    watch.forEach(function (el) { io.observe(el); });

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);

    /* Coming back to a tab re-measures. Without it a reader who leaves
       mid-article and returns can find the bar in whatever state the
       last frame before she left had left it. */
    document.addEventListener('visibilitychange', schedule);

    measure();
  })();

  /* ---------- 8 · the reading line ----------
     Fills the three-pixel line at the top of the viewport as she moves
     down the document. Why it exists rather than a shorter article is
     at #bl-rprog in index.html.

     IT MEASURES THE WHOLE DOCUMENT, NOT THE PROSE. Measuring to the end
     of the argument was tried first and it is wrong, because it reaches
     100% with the reviews, the FAQ and the glossary still below her.
     A line that says finished while the page keeps going is worse than
     no line, and a reader who has been told she is done and is not will
     not trust the second half of anything on the page. Full document,
     always, even though the last stretch is not the argument.

     scrollHeight - clientHeight can be 0 on a page shorter than the
     viewport, and 0/0 is NaN. The guard is not theoretical: with the
     offer sheet open the body is locked and the article behind it is
     not scrollable, which is exactly when this would otherwise write
     "NaN%" into a style attribute and leave the line stuck.

     rAF-throttled on the same pattern as the sweep in section 2, and
     for the same reason. A scroll handler that writes a style on every
     event is the jank this file spends most of its length avoiding. */
  (function () {
    var fill = document.getElementById('bl-rprog-fill');
    if (!fill) return;

    var queued = false;

    function paint() {
      queued = false;
      var se = document.scrollingElement || document.documentElement;
      var span = se.scrollHeight - se.clientHeight;
      if (span <= 0) { fill.style.width = '0%'; return; }
      var pct = (se.scrollTop / span) * 100;
      if (pct < 0) pct = 0;
      if (pct > 100) pct = 100;
      fill.style.width = pct.toFixed(2) + '%';
    }

    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(paint);
    }

    window.addEventListener('scroll', schedule, { passive: true });
    /* Resize changes the denominator, and so does the article growing:
       every figure that rises and every lazy image that lands makes the
       document taller, which silently inflates the percentage she was
       shown a moment ago. Re-measuring on load catches the images. */
    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);

    paint();
  })();
})();
